import { sleep } from '@last/core'

import { useTabsStore } from '@/store/tabs'
import type { Terminal } from '@/types/config'
import { wakeablePayment } from '@/utils/wakeablePayments'

import { type IDataphone } from './dataphone'

type ChargeResponse = {
  status: 'confirmed' | 'rejected' | 'expired'
  tip?: number
}

export class IntegratorDataphone implements IDataphone {
  public initialized: boolean = false
  public canCancel: boolean = false

  private config: Terminal

  constructor(config: Terminal) {
    this.initialized = false
    this.config = config
  }

  init() {
    this.initialized = true
    return true
  }

  async charge({
    amount,
    tip,
    paymentId,
    billId
  }: {
    amount: number
    tip: number
    paymentId: string
    billId: string
  }) {
    if (!this.initialized) throw new Error('Dataphone is not initialized')
    const { addPaymentRequest, changePaymentRequest } = useTabsStore()

    const { terminalId, integratorId } = this.config
    addPaymentRequest(paymentId, billId, amount, tip, terminalId, integratorId)

    const response = (await Promise.race([
      wakeablePayment(paymentId),
      sleep(150000)
    ])) as ChargeResponse

    if (!response) {
      changePaymentRequest(paymentId, 'expired')
      throw new Error('Payment request expired')
    } else if (response.status === 'rejected') {
      throw new Error('Payment request rejected')
    } else {
      return response
    }
  }

  async cancel(_: { paymentId: string }) {
    throw new Error('Cancel not supported by IntegratorDataphone at the moment')
  }

  async refund(_: { paymentId: string }) {
    throw new Error('Refund not supported by IntegratorDataphone at the moment')
  }
}
